


export const uploadContentLinkLabel = "UPLOAD CONTENT (PDF, DOC, TXT)";

export const previewDocumentContent = [
  "Inflation is the sustained increase in the general price level of goods and services over time. When inflation rises, each unit of currency buys fewer goods, reducing purchasing power for households and businesses.",
  "Teachers often explain inflation with everyday examples: a loaf of bread that cost $2 last year might cost $2.20 today. Connecting price changes to supply, demand, and central bank policy helps students grasp why inflation matters.",
];

export {
  familiarTopics as familiarConcepts,
  familiarTopicsHeading as familiarConceptsHeading,
} from "../shared/familiarTopics";

export const understandingLevelHeading = "UNDERSTANDING LEVEL";

export const understandingLevelOptions = [
{ id: "below", label: "BELOW GRADE" },
{ id: "on", label: "ON GRADE" },
{ id: "above", label: "ABOVE GRADE" }];


export const createDiverseExplanationsLabel = "Create Diverse Explanations";
export const createDiverseExplanationsHint =
"Create 4 different ways to explain this concept";

export const generatingExplanationsMessage = "Creating diverse explanations…";

export const strategyTabsHeading = "CHOOSE A WAY THAT FITS YOUR STUDENTS";

export const defaultExplainDifferentlyConfig = {
  selectedConceptId: "",
  selectedConceptLabel: "",
  topicText: "",
  pastedContent: "",
  understandingLevel: "on",
};